import React from 'react'

const BackgroundOrb = ({ blok }) => {
 
    let cssStyles = ' background-orb';
    cssStyles += ' ' + blok.color;
    cssStyles += ' size_' + blok.size;
    cssStyles += ' vertical_' + blok.position_vertical;
    cssStyles += ' horizontal_' + blok.position_horizontal;  
    cssStyles += (blok.disable_mobile) ? ' disable_mobile' : "";  

    return (
        <div className={cssStyles} style={{ 
            top: `${blok.custom_position_vertical ? `${blok.custom_position_vertical}%` : ''}`,
            left: `${blok.custom_position_horizontal ? `${blok.custom_position_horizontal}%` : ''}`   
        }}> 
        </div>
    )
}

export default BackgroundOrb